import { useQuery } from "@tanstack/react-query";
import {
  IGetAllTitleConfigurationsList,
  ITitleConfigurationRow,
} from "../utils/types";
import { apiFetch } from "@core/index";
import { enqueueSnackbar } from "notistack";
import { apiEndpoint } from "../utils/constants";
import { buildQueryParams } from "@shared/utils/functions";

export type TitleConfigurationsListResponse = {
  data: ITitleConfigurationRow[];
  pagination: {
    total: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
  };
};
// React Query hook: Fetch the list of title configurations with filters and pagination
export const useGetAllTitleConfigurationsList = (
  config: IGetAllTitleConfigurationsList,
) => {
  return useQuery<
    TitleConfigurationsListResponse,
    Error,
    TitleConfigurationsListResponse,
    (string | boolean | undefined)[]
  >({
    queryKey: [
      "titleConfigurationList",
      config.data.pageNumber,
      config.data.pageSize,
      config.data.includeInactive,
      config.data.searchQuery ?? "",
      config.data.orderBy ?? "",
      config.data.order ?? "",
    ],
    queryFn: async () => {
      const queryString = buildQueryParams(config.data);
      const url = `${apiEndpoint}?${queryString}`;

      try {
        const data = await apiFetch<TitleConfigurationsListResponse>(url);
        return data;
      } catch (e) {
        const message =
          e instanceof Error
            ? e.message
            : "Failed to fetch title configurations";
        enqueueSnackbar(message, {
          variant: "error",
          autoHideDuration: 5000,
          preventDuplicate: true,
        });
        throw e;
      }
    },
    // keep previous data to avoid flicker when paginating
    placeholderData: (prev) => prev,
    staleTime: 30_000,
  });
};
